import { delayFetchMessageAttachments } from 'core_main/api/messages';
import { updateSessionMessages } from 'core_main/api/sessions';
import Pubnub from 'pubnub';
import { runListenersForOnMessageReceivedEvent } from '../helpers/chatMessageReceived';
import { getMetaPubNub } from '../helpers/instance';

export const markMessagesAsDelivered = (
  messageEvents: any[],
  sessionId: string,
) => {
  const messageIds: string[] = [];

  messageEvents.forEach((messageEvent) => {
    const { timetoken: messageTimetoken, channel, message } = messageEvent;

    const { id } = message.data;

    messageIds.push(id);

    getMetaPubNub()?.instance?.addMessageAction({
      channel,
      messageTimetoken,
      action: {
        type: 'delivery',
        value: 'success',
      },
    });
  });

  updateSessionMessages({
    sessionId,
    messageIds,
    body: { delivered: true },
  });
};

export const handleChatMessageReceivedEvent = (
  messageEvent: Pubnub.MessageEvent,
) => {
  const { message } = messageEvent;

  const { attachments, session } = message.data.relationships;
  const messageData = message.data;
  const { included } = message;
  const { id: messageId, attributes } = messageData;

  const sessionId = session.data.id;
  const { direction } = attributes;

  if (direction === 'out') {
    markMessagesAsDelivered([messageEvent], sessionId);
  }

  if (attachments?.data?.length) {
    delayFetchMessageAttachments(messageId).then((response) => {
      const attachmentData = response.data;
      runListenersForOnMessageReceivedEvent(
        messageData,
        attachmentData,
        included,
      );
    });

    return;
  }

  runListenersForOnMessageReceivedEvent(messageData, undefined, included);
};
